import React, { useState } from "react";
import { Link } from "react-router-dom";

const LINKS = [
  { to: "/enterprise", label: "Home", key: "home" },
  { to: "/enterprise/solution", label: "What We Build", key: "solution" },
  { to: "/enterprise/about", label: "About", key: "about" },
  { to: "/enterprise/research", label: "Research", key: "research" },
  { to: "/enterprise/contact", label: "Contact", key: "contact" },
];

export function Nav({ active }) {
  const [open, setOpen] = useState(false);
  return (
    <nav className="mkt-nav" data-testid="mkt-nav">
      <div className="mkt-nav-inner">
        <Link to="/?choose=1" className="mkt-nav-brand" data-testid="mkt-nav-brand" aria-label="Crowther — Home">
          <img src="/logos/wordmark-black-fit.png" alt="Crowther" className="mkt-nav-logo" />
        </Link>
        <div className={`mkt-nav-links${open ? " open" : ""}`}>
          {LINKS.map((l) => (
            <Link
              key={l.key}
              to={l.to}
              aria-current={active === l.key ? "page" : undefined}
              data-testid={`mkt-nav-${l.key}`}
              onClick={() => setOpen(false)}
            >
              {l.label}
            </Link>
          ))}
        </div>
        <div className="mkt-nav-cta">
          <Link
            to="/machines"
            className="mkt-nav-cross"
            data-testid="mkt-nav-machines"
            onClick={() => setOpen(false)}
          >
            <span>For Machines</span>
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden>
              <path d="M7 17L17 7M9 7h8v8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </Link>
          <Link to="/plan" className="mkt-btn mkt-btn-primary" data-testid="mkt-nav-cta">
            Get Your Firm&rsquo;s Free Customised AI Roadmap
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden>
              <path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </Link>
          <button
            type="button"
            className="mkt-nav-menu-btn"
            onClick={() => setOpen((v) => !v)}
            aria-label="Menu"
            data-testid="mkt-nav-menu"
          >
            <svg width="26" height="18" viewBox="0 0 26 18" fill="none" aria-hidden>
              <path d="M0 1h26M0 9h26M0 17h26" stroke="#161E1B" strokeWidth="1.5"/>
            </svg>
          </button>
        </div>
      </div>
    </nav>
  );
}
